import{nodeViewDecorators as o}from"ricos-common-plugins/viewer";import{Decorators as r}from"./nodeViewDecorators.js";const t=o;export{t as decorators,r as default};
//# sourceMappingURL=index.js.map
